/*  ==========================================================================
    Event listener for DOM content loaded
============================================================================== */

document.addEventListener("DOMContentLoaded", async (event) => {
  console.log(`Event triggered :: ${event.type}`, event);

  const [cart, cartAdditionalData] = await Promise.all([AuroraServices.getCart(), AuroraUtils.getCartAdditionalData()]);
  const customer = AuroraCustomer.init();

  AuroraUtils.init();
  AuroraNavigation.init();
  AuroraCart.init();
  AuroraProduct.init();
  AuroraProductZoom.init();
  if (window.AuroraIdleLoader && typeof window.AuroraIdleLoader.schedule === "function") {
    window.AuroraIdleLoader.schedule(
      () => {
        AuroraSiteTour.init();
        AuroraCarousel.init();
      },
      { timeout: 1500 }
    );
  }
  AuroraMobileSearch.init();

  if (typeof AuroraAccount !== "undefined" && typeof AuroraAccount.init === "function") {
    await AuroraAccount.init();
  }

  // check Cart for Bundle Consistency
  const isChanged = AuroraCart.checkBundleConsistency(cart);
  if (isChanged) {
    // prevents infinite loop
    return;
  }
  // render cart line items
  await AuroraRender.cartLineItems(cart, cartAdditionalData);
  // render cart subotal, total items, cart messages, etc...
  AuroraRender.cartStates(cart);
  // render presciption limits, warnings, etc...
  AuroraRender.customerStates(customer, cart, cartAdditionalData);
  // update cart attributes for checkout
  AuroraCart.updateCartAttributes(customer, cart, cartAdditionalData);
  // update checkout button usability (cart page only)
  AuroraRender.updateCheckoutButtonState(customer, cart, cartAdditionalData);
  // register event listener to the cart line items
  AuroraCart.registerEventListenerOnCartLineItems();
  // register Wishlist
  AuroraCart.initCartAddToWishlist();

  (document.querySelectorAll(".header-supporting-menu .aur-menu__item.has-mega-menu a") || []).forEach((link) => {
    link.addEventListener("click", () => {
      window.innerWidth >= 992 && AuroraUtils.setCSSVars();
    });
  });

  
  if (!document.body.classList.contains("template--login")) {
    const prescriptionicon = document.querySelector(".js--toggle-prescription");
    prescriptionicon.addEventListener("click", () => {
      showPrescriptionBanner({
        showdelay: 0,
        autohide: 10000,
        hideElements: [".header-cart-column"],
      });
    });
  }
});

/*  ==========================================================================
    Event listener for product(s) being added to cart
============================================================================== */

document.addEventListener("aurora::addToCart", async (event) => {
  console.log(`Event triggered :: ${event.type}`, event.detail);

  const { data, items, status } = event.detail;

  // get cart and customer
  const [cart, cartAdditionalData] = await Promise.all([AuroraServices.getCart(), AuroraUtils.getCartAdditionalData()]);
  const customer = AuroraCustomer.getCustomer();

  // log updated cart
  console.log("[ aurora::addToCart ] :: cart...", cart);

  if (200 === status) {
    // render add to cart success message
    AuroraRender.addToCartSuccess(data, items);
    // render all cart line items
    await AuroraRender.cartLineItems(cart, cartAdditionalData);
    // render cart subotal, total items, cart messages, etc...
    AuroraRender.cartStates(cart);
    // render presciption limits, warnings, etc...
    AuroraRender.customerStates(customer, cart, cartAdditionalData, true);
    // update cart attributes for checkout
    AuroraCart.updateCartAttributes(customer, cart, cartAdditionalData);
    // register event listener to the cart line items
    AuroraCart.registerEventListenerOnCartLineItems();
    const isChanged = AuroraCart.checkBundleConsistency(cart);
    if (isChanged) {
      // prevents infinite loop
      return;
    }
  } else {
    AuroraRender.addToCartFail();
  }
});

/*  ==========================================================================
    Event listener for cart line item changes
============================================================================== */

document.addEventListener("aurora::cartLineItemChanged", async (event) => {
  console.log(`Event triggered :: ${event.type}`, event.detail);

  const { cart, status } = event.detail;
  const cartAdditionalData = await AuroraUtils.getCartAdditionalData();
  const customer = AuroraCustomer.getCustomer();

  if (200 === status) {
    // check Cart for Bundle Consistency
    const isChanged = AuroraCart.checkBundleConsistency(cart);
    if (isChanged) {
      return;
    }
    // render cart line items
    await AuroraRender.cartLineItems(cart, cartAdditionalData);
    // render cart subotal, total items, cart messages, etc...
    AuroraRender.cartStates(cart);
    // render presciption limits, warnings, etc...
    AuroraRender.customerStates(customer, cart, cartAdditionalData);
    // update cart attributes for checkout
    AuroraCart.updateCartAttributes(customer, cart, cartAdditionalData);
    // update checkout button usability (cart page only)
    AuroraRender.updateCheckoutButtonState(customer, cart, cartAdditionalData);
    // register event listener to the cart line items
    AuroraCart.registerEventListenerOnCartLineItems();
  }
});

/*  ==========================================================================
    Event listener for cart terms and conditions changes
============================================================================== */

document.addEventListener("aurora::termsConditionsChanged", async (event) => {
  console.log(`Event triggered :: ${event.type}`);

  const [cart, cartAdditionalData] = await Promise.all([AuroraServices.getCart(), AuroraUtils.getCartAdditionalData()]);
  const customer = AuroraCustomer.getCustomer();

  // update checkout button usability (cart page only)
  AuroraRender.updateCheckoutButtonState(customer, cart, cartAdditionalData);
});

/*  ==========================================================================
    Event listener for window resize
============================================================================== */

window.addEventListener(
  "resize",
  AuroraUtils.throttle(() => AuroraUtils.setCSSVars(), 150)
);

/*  ==========================================================================
    Event listener for window scroll
============================================================================== */

window.addEventListener(
  "scroll",
  AuroraUtils.throttle(() => {
    AuroraUtils.setScrollPositionWithClasses();
  }, 175)
);

/*  ==========================================================================
    Event listener for window "load" event
============================================================================== */

window.addEventListener("load", (event) => {
  console.log(`Event triggered :: ${event.type}`, event);
});

